import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import ModalOverlay from 'builder/components/ModalOverlay'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors as userSelectors } from 'builder/modules/user'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { actions } from 'builder/modules/resumeEditor'
import paywallVisual from 'images/builder/ai-cover-letters/paywall.png'
import {
  Container,
  CloseIcon,
  CloseIconWrapper,
  Visual,
  Content,
  Title,
  Text,
  ButtonContainer,
  UnlockFeaturesContainer,
  UnlockTitle,
  FeaturesWrapper,
  FeatureItem,
  FeatureIcon,
  FeatureText,
} from './styles'

const LOCALIZATION_KEY = 'builder.resume_editor.ai_review_panel.paywall_modal'

export const AiResumeReviewPaywall = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const upgradeUrl = useTypedSelector(userSelectors.getUpgradeUrl)
  const dispatch = useDispatch()

  useEffect(() => {
    trackInternalEvent('see_ai_review_paywall')
  }, [])

  const handleUpgradeClick = () => {
    goToBillingPlanPage({ upgradeURL: upgradeUrl, onSuccessRedirect: window.location.href })
    trackInternalEvent('click_upgrade', {
      label: 'ai_review_paywall',
    })
  }

  const handleClose = useCallback(() => {
    dispatch(actions.setIsAiResumeReviewPaywallModalOpen(false))
  }, [dispatch])

  return (
    <ModalOverlay
      fullScreen={isPhone}
      overlayFadeDuration={250}
      contentSlideDuration={300}
      onClick={handleClose}
    >
      <Container data-testid="ai-resume-review-paywall">
        <Visual src={paywallVisual} />

        <Content>
          <Title>{i18n.t(`${LOCALIZATION_KEY}.title`)}</Title>
          <Text>{i18n.t(`${LOCALIZATION_KEY}.description`)}</Text>
        </Content>

        <UnlockFeaturesContainer>
          <UnlockTitle>{i18n.t(`${LOCALIZATION_KEY}.unlock_features_section.title`)}</UnlockTitle>
          <FeaturesWrapper>
            <FeatureItem>
              <FeatureIcon />
              <FeatureText>
                {i18n.t(`${LOCALIZATION_KEY}.unlock_features_section.feature_1`)}
              </FeatureText>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon />
              <FeatureText>
                {i18n.t(`${LOCALIZATION_KEY}.unlock_features_section.feature_2`)}
              </FeatureText>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon />
              <FeatureText>
                {i18n.t(`${LOCALIZATION_KEY}.unlock_features_section.feature_3`)}
              </FeatureText>
            </FeatureItem>
          </FeaturesWrapper>
        </UnlockFeaturesContainer>

        <ButtonContainer>
          <ButtonV2
            theme={ButtonTheme.ghost}
            onClick={handleClose}
            data-testid="cancel-ai-resume-review-paywall-button"
          >
            {i18n.t(`${LOCALIZATION_KEY}.cancel_button`)}
          </ButtonV2>
          <ButtonV2
            onClick={handleUpgradeClick}
            data-testid="continue-ai-resume-review-paywall-button"
          >
            {i18n.t(`${LOCALIZATION_KEY}.continue_button`)}
          </ButtonV2>
        </ButtonContainer>

        <CloseIconWrapper showHoverState={true} onClick={handleClose}>
          <CloseIcon />
        </CloseIconWrapper>
      </Container>
    </ModalOverlay>
  )
}
